import { Box, Rating, Typography } from '@mui/material';

import FeedbackField from './FeedbackField';
import {
  FEEDBACK_ACCENT,
  FEEDBACK_TYPES,
  MAX_BODY_LENGTH,
  RATING_CATEGORIES,
} from './constants';

const FeedbackContentSection = ({
  feedbackType,
  unknownTopic,
  ratings,
  texts,
  body,
  setBody,
  onChangeRating,
  onChangeText,
  fieldsDisabled,
  clearStatus,
}) => {
  if (feedbackType === FEEDBACK_TYPES.SESSION) {
    return (
      <Box>
        <Typography id="ratings-hint" fontWeight={700} mb={1}>
          Rate your session
        </Typography>
        <Typography mb={3} fontSize={14} sx={{ opacity: 0.8 }}>
          Rate at least one category. Comments are optional.
        </Typography>
        {RATING_CATEGORIES.map(({ key, label }) => {
          const labelId = `feedback-rating-label-${key}`;
          return (
            <Box key={key} mb={4}>
              <Typography id={labelId} fontWeight={700} mb={1.5} component="label">
                {label}
              </Typography>
              <Rating
                name={`rating-${key}`}
                value={ratings[key]}
                max={5}
                size="large"
                disabled={fieldsDisabled}
                onChange={(_, value) => onChangeRating(key, value)}
                aria-labelledby={labelId}
                aria-describedby="ratings-hint"
                getLabelText={(n) => `${n} Star${n !== 1 ? 's' : ''}`}
                sx={{
                  color: FEEDBACK_ACCENT,
                  display: 'flex',
                  mb: 2,
                  '& .MuiRating-iconEmpty': { color: 'rgba(255,255,255,0.35)' },
                  '& .MuiRating-icon': { fontSize: 40 },
                }}
              />
              <FeedbackField
                id={`feedback-text-${key}`}
                multiline
                minRows={3}
                aria-label={`Optional comments about ${label}`}
                placeholder={`Optional comments about ${label.toLowerCase()}...`}
                disabled={fieldsDisabled}
                value={texts[key]}
                maxLength={MAX_BODY_LENGTH}
                onChange={(e) => onChangeText(key, e.target.value)}
              />
            </Box>
          );
        })}
      </Box>
    );
  }

  return (
    <FeedbackField
      id="feedback-body"
      multiline
      minRows={8}
      required
      aria-required="true"
      label="Your feedback"
      helperText="Required. Be as specific as you like."
      placeholder="Type your feedback here..."
      disabled={fieldsDisabled || unknownTopic}
      value={body}
      maxLength={MAX_BODY_LENGTH}
      onChange={(e) => {
        setBody(e.target.value);
        clearStatus();
      }}
    />
  );
};

export default FeedbackContentSection;
